import logoMobile from 'images/logo_blue.svg';
import logoSrc from 'images/logo_text_blue.svg';
import styled from 'styled-components';

interface LogoProps {
  mobile?: boolean;
}

function Logo(props: LogoProps) {
  const { mobile } = props;

  return <StyledLogo src={mobile ? logoMobile : logoSrc} alt="Fiter Manager" />;
}

const StyledLogo = styled.img`
  height: 100%;
  width: 100%;
`;

export default Logo;
